module.exports = __webpack_public_path__ + "static/media/eo.eece65ff.svg";